import { render, staticRenderFns } from "./MspForsageOrdersItemStatus.vue?vue&type=template&id=76d81bde&scoped=true&"
import script from "./MspForsageOrdersItemStatus.vue?vue&type=script&lang=js&"
export * from "./MspForsageOrdersItemStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d81bde",
  null
  
)

export default component.exports